import React from 'react';

/** Ethora Bot brand asset served from CRA public/ */
export const EDUGENIE_AVATAR_SRC = `${process.env.PUBLIC_URL || ''}/ethorabot3.png`;
console.log(EDUGENIE_AVATAR_SRC);

export const ETHORA_BOT_AVATAR_SRC = EDUGENIE_AVATAR_SRC;

export const EduGenieAvatarImg = ({ className = '', alt = 'Ethora Bot' }) => (
  <img
    src={EDUGENIE_AVATAR_SRC}
    alt={alt}
    className={className}
    draggable={false}
  />
);

export const EthoraBotAvatarImg = EduGenieAvatarImg;
